const includes = (string, term) => {
  return new RegExp(term, "i").test(string);
};
const searchMenuByLabel = (items, query) => {
  if (!query || query.trim() === "") {
    return items;
  }
  const filterNodes = (nodes) => {
    return nodes.map((node) => {
      const matchesSelf = includes(node.label, query);
      const matchingChildren = node.children ? filterNodes(node.children) : [];
      if (matchesSelf || matchingChildren.length > 0) {
        return {
          ...node,
          children: matchingChildren
        };
      }
      return null;
    }).filter((item) => item !== null);
  };
  return filterNodes(items);
};

export { includes, searchMenuByLabel };
